exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".active-nav-link[data-v-534f685a]{text-decoration:underline}", ""]);

// exports
